import { SideMenu } from '../models/common.model';
import { GlobalContants } from './global.contants';

// export const language = ['en', 'ar'];

export const commonContants = {
  defaultLanguage: 'en',
  englishCode: 'en',
  arabicCode: 'ar',
};
export const actionIdConstants = {
  Add_Objectives: 1,
  Add_Groups: 2,
  Add_Reports: 3,
  Update_Objectives: 4,
  Update_Groups: 5,
  Update_Reports: 6,
  Profile_Update: 7,
  Sync_Process: 8,
  Csv_Upload: 9,
  View_Objective: 10,
  View_Group: 11,
  View_Report: 12,
  Csv_Template: 14,
  User_Login: 13,
  Download_Report_Pdf: 15,
  Share_Report: 16,
  User_Logout: 17,
  Save_Report: 18,
  Add_Subscription_Master: 19,
  Update_Subscription_Master: 20,
  Add_User_Subscription: 21,
  Update_User_Subscription: 22,
  Add_Search_Master: 23,
  Update_Search_Master: 24,
  Delete_Search_Master: 25,
  Add_Parameter_Master: 26,
  Update_Parameter_Master: 27,
  Delete_Parameter_Master: 28,
  Update_Report_Filter: 29,
  Setting_Update: 30,
  Package_Plan_Request: 31,
  Add_Project: 32,
  Update_Project: 33,
  Share_Project: 34,
  Un_share_project: 35,
  Apply_Filter: 36,
  Pdf_Download: 37,

  set_catchment: 38,
  save_catchment: 39,
  universal_search: 40,
  download_data: 41,
  show_on_map: 42,
  explore_neighbourhood: 43,
  explore_project: 44,
  explore_property: 45,
  show_floor_map: 46,
  change_language: 47,
  click_parcel: 48,
  view_map_only: 49,
  view_report_with_map: 50,
  view_report_only: 51,
  recent_search: 52,
};
export const menuList: SideMenu[] = [
  //     {
  //     index: 1,
  //     icon: 'markets',
  //     image: '',
  //     title: 'dashboard',
  //     isVisible: true,
  //     isDisable: false,
  //     routeUrl: `/${GlobalContants.Routes.Dashboard}`
  // },
  {
    index: 1,
    icon: 'description',
    title: 'myQueries',
    image: '',
    isVisible: true,
    isDisable: false,
    routeUrl: `/${GlobalContants.Routes.Reports}`,
  },
  {
    index: 2,
    icon: 'bookmark',
    title: 'mySavedQueries',
    image: '',
    isVisible: true,
    isDisable: false,
    routeUrl: `/${GlobalContants.Routes.BookMark}`,
  },
  {
    index: 3,
    icon: 'micMenu',
    title: 'aiReports',
    image: '',
    isVisible: false,
    isDisable: false,
    routeUrl: `/${GlobalContants.Routes.SampleReport}`,
  },
  {
    index: 4,
    icon: 'cacheIcon',
    title: 'Generate Cache',
    image: '',
    isVisible: false,
    isDisable: false,
    routeUrl: `/${GlobalContants.Routes.generateCache}`,
  },
];

export const countryCode = {
  saudi: 'SA',
  kuwait: "KWT",
  bahrain: "BHR"
};

export const tableTitle = {
  houseVillaInventoryProjects: 'House Villa Inventory Projects', // done
  houseVillaProperties: 'HouseVilla Properties',
  houseVillaIndependentProperties: 'House Villa Independent Properties', // done
  houseVillaGovernmentalProperties: 'House Villa Governmental Properties', // done
  investmentInventoryProperties: 'Investment Inventory Properties', // done
  officeInventoryNeighborhood: 'Office Inventory Neighborhood', // done
  officeInventoryProperties: 'Office Inventory Properties', // done
  officeRentalProperty: 'Office Rental Properties', // done
  officeRentalUnitSize: 'Office Rental Unit Size', // done
  rentalUnit: 'Rental Unit', // done
  propertyTransactions: 'Property Transactions', // done
  unitTransactions: 'Unit Transactions', // done
  residentialDetail: 'Residential Detail', // done
  residentialPrimeLand: 'Residential Prime Land', // done
  residentialPrimeProject: 'Residential Prime Project', // done
  residentialPrimeRental: 'Residential Prime Rental', // done
  residentialPrimeTransaction: 'Residential Prime Transaction', // done
  retailInventoryDepartment: 'Retail Inventory Department', // done
  retailInventoryTenants: 'Retail Inventory Tenants', // done
  retailRentMallWise: 'Retail Rent Mall Wise', // done
  retailRentalUnitSize: 'Retail Rental Unit Size', // done
  retailUnitInProperty: 'Retail Unit In Property', // done
  warehouseInventoryNeighborhood: 'Warehouse Inventory Neighborhood', // done
  warehouseRentalProperty: 'Warehouse Rental Properties', // done
  warehouseRentalUnitSize: 'Warehouse Rental Unit Size', // done
  retailInventoryProperties: 'Retail Inventory Properties', // done
  warehouseInventoryProperties: 'Warehouse Inventory Properties', // done
};
